/* hb-printings.js — "Other printings we have" on a card's product page.
 *
 * Landing on one printing and seeing every printing we hold, priced, is the
 * core behaviour of a singles marketplace. Shopify has no native equivalent.
 *
 * Deliberately renders into Trade's EXISTING shelf-rail markup
 * (.pdpr__rail / .pdpr__card / .pdpr__art / .pdpr__name / .pdpr__price) so it
 * needs no new CSS and matches the rails already on the page.
 *
 * Name matching reuses HBCombo.norm()/front() — combo-indicators.md warns that
 * this normalisation must never diverge from hb-combo.js, so we borrow it
 * rather than reimplement it.
 */
(function () {
  'use strict';

  var Q = String.fromCharCode(63);
  var LIMIT = 10;               /* /search/suggest.json caps at 10 */

  function norm(s) {
    if (window.HBCombo && HBCombo.norm && HBCombo.front) {
      return HBCombo.norm(HBCombo.front(s || ''));
    }
    return (s || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  /* "Sol Ring (288) (Pool Party Foil) [SLD - 288]" -> "Sol Ring" */
  function cardName(title) {
    return (title || '').split(' [')[0].split(' (')[0].trim();
  }

  /* the bit inside the brackets, which is what actually differs between
     printings: "Sol Ring [CMD - 261]" -> "CMD - 261" */
  function printingLabel(title) {
    var t = title || '';
    var m = /\[([^\]]+)\]\s*$/.exec(t);
    var base = m ? m[1] : t;
    /* two Secret Lair printings can share a set code, so keep the qualifier
       in brackets - "(Pool Party Foil)" - and drop the bare collector number. */
    var q = (t.match(/\(([^)]+)\)/g) || []).map(function (x) { return x.slice(1, -1); })
      .filter(function (x) { return !/^\d+[a-z]?$/i.test(x); });
    return q.length ? base + ' \u00b7 ' + q.join(' \u00b7 ') : base;
  }

  function money(n) {
    return '$' + (Math.round(n * 100) / 100).toFixed(2);
  }

  function currentHandle() {
    var p = window.location.pathname.split('/products/')[1];
    return p ? p.split(Q)[0].split('/')[0] : '';
  }

  /* Live-verify rather than trusting the search index: ask the product which
     variant is actually available and what it costs right now. */
  function verify(hit) {
    return fetch('/products/' + hit.handle + '.js', { headers: { accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants) return null;
        for (var i = 0; i < p.variants.length; i++) {
          if (p.variants[i].available) {
            return {
              handle: hit.handle,
              url: '/products/' + hit.handle,
              title: p.title,
              label: printingLabel(p.title),
              price: p.variants[i].price / 100,
              cond: p.variants[i].title || '',
              img: (p.featured_image || hit.image || '')
            };
          }
        }
        return null;
      })
      .catch(function () { return null; });
  }

  function render(list, name) {
    var sec = document.getElementById('hbpOther');
    var rail = document.getElementById('hbpRail');
    var sub = document.getElementById('hbpSub');
    if (!sec || !rail) return;

    rail.innerHTML = list.map(function (p) {
      var img = p.img
        ? '<img src="' + p.img + (p.img.indexOf(Q) > -1 ? '&' : Q) + 'width=400" loading="lazy" width="60" height="84" alt="">'
        : '';
      return '<a class="pdpr__card" href="' + p.url + '">' +
             '<span class="pdpr__art">' + img + '</span>' +
             '<span class="pdpr__name">' + p.label + '</span>' +
             '<span class="pdpr__price">' + money(p.price) + '</span>' +
             '</a>';
    }).join('');

    if (sub) {
      var cheapest = list[0].price;
      sub.textContent = list.length === 1
        ? 'We also hold ' + name + ' in one other printing.'
        : 'We hold ' + name + ' in ' + (list.length + 1) + ' printings. The cheapest other one is ' +
          money(cheapest) + '.';
    }
    sec.hidden = false;
  }

  function start() {
    var rail = document.getElementById('hbpRail');
    if (!rail) return;

    var box = document.querySelector('.pdpx');
    var name = (box && box.getAttribute('data-card')) || cardName(document.title);
    if (!name) return;
    var key = norm(name);
    var here = currentHandle();

    fetch('/search/suggest.json' + Q + 'q=' + encodeURIComponent(name) +
          '&resources[type]=product&resources[limit]=' + LIMIT,
          { headers: { accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var hits = (j && j.resources && j.resources.results && j.resources.results.products) || [];
        var mine = hits.filter(function (h) {
          return h.handle !== here && norm(cardName(h.title)) === key;
        });
        if (!mine.length) return null;
        return Promise.all(mine.map(verify));
      })
      .then(function (found) {
        if (!found) return;
        var live = found.filter(Boolean).sort(function (a, b) { return a.price - b.price; });
        if (!live.length) return;          /* every other printing sold out - show nothing */
        render(live, name);
      })
      .catch(function () { /* stay hidden */ });
  }

  function boot() {
    if (window.HBCombo) { start(); } else { setTimeout(boot, 120); }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(boot, 200); });
  } else { setTimeout(boot, 200); }
})();
